import React from "react";
import ApprovalList from "./ApprovalList";
import { diffMin, fmtMin } from "./dateUtil";

// 残業 承認ページ（管理者）。共通の ApprovalList に列/カード/APIを渡すだけの薄い実装。
// 社員が登録した残業申請（申請中）を承認/却下する。残業時間は開始/終了から計算して表示。

const CONFIG = {
  title: "残業の承認",
  // NAV のキーと一致させる（経営者の承認の入口は勤怠履歴）。詳細は LeaveApprovalPage を参照。
  active: "attendance",
  listPath: "/api/employee/overtime/list",
  decidePath: "/api/employee/overtime/decide",
  emptyText: "残業がありません",
  fields: [
    { header: "社員", value: (r) => r.employee_name, nowrap: true, primary: true },
    { header: "日付", value: (r) => r.date || "-", nowrap: true },
    { header: "残業時間", value: (r) => (r.start && r.end ? `${r.start}〜${r.end}（${fmtMin(diffMin(r.start, r.end))}）` : "-"), nowrap: true },
    { header: "理由", value: (r) => r.reason || "-", muted: true, wrap: true, minWidth: 160 },
  ],
  // 残業は申請中のみ承認/却下できる（承認済・却下は操作不可）。
  approvable: (r) => r.status === "pending",
  rejectable: (r) => r.status === "pending",
};

function OvertimeApprovalPage() {
  return <ApprovalList config={CONFIG} />;
}

export default OvertimeApprovalPage;
